/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./RoutedMessagesBubble.vue?vue&type=template&id=559e558a&scoped=true"
import script from "./RoutedMessagesBubble.vue?vue&type=script&lang=js"
export * from "./RoutedMessagesBubble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559e558a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('559e558a')) {
      api.createRecord('559e558a', component.options)
    } else {
      api.reload('559e558a', component.options)
    }
    module.hot.accept("./RoutedMessagesBubble.vue?vue&type=template&id=559e558a&scoped=true", function () {
      api.rerender('559e558a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/routedMessages/RoutedMessagesBubble.vue"
export default component.exports